import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { SelfDiagnosticStepEffects } from './effects';
import { reducer } from './reducer';
import { SelfDiagnosticStepFacade } from './facade';
import { stateName } from './selectors';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature(stateName, reducer), EffectsModule.forFeature([SelfDiagnosticStepEffects])],
  exports: [],
  providers: [SelfDiagnosticStepFacade],
  declarations: [],
})
export class SelfDiagnosticStepStateModule {}
